import {
  CardContent,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tooltip,
  Typography,
  withStyles,
} from "@material-ui/core";
import { isThisMinute } from "date-fns";
import React, { useEffect, useRef, useState } from "react";
import PerfectScrollbar from "react-perfect-scrollbar";
import StyledTableRow from "../../components/StyledTableRow";
import {
  convertToThousands,
  getUniqueValues,
  _isNaN,
  countOrACVFormatter,
} from "../../util/customFunctions";
import * as d3 from "d3";
import { getMixKey } from "../../util/generateHeadings";
import {
  customSortedOppType,
  customSortedSegments,
} from "../../util/customSortings";
import { deSnake } from "../../util/dataFormatter";
import { color } from "d3";
import CopyTablesObject from "../../components/xlsx-export/CopyTablesObject";
// import ExcelExportButton from "../../components/xlsx-export/xlsxexport";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import CustomWidthTooltip from "../../components/Buttons/Expand_Collapse_Tooltip";

const useStyle = makeStyles((theme) => ({
  root: {},
  sticky: {
    position: "sticky",
    left: 0,
    background: "white",
    zIndex: 10,
    "&::after": {
      content: '""',
      position: "absolute",
      top: 0,
      bottom: 0,
      right: 0,
      width: "1px",
      background: "lightgrey",
    },
  },
  stickyHeader: {
    position: "sticky",
    top: 0,
    background: "white",
    zIndex: 25, // Higher than sticky columns
  },
  content: { 
    width: "100%",
    padding: "1rem !important"
  },
  table: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
  },
  repText: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    minWidth: "169px",
    fontWeight: "inherit",
  },
  repNumber: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    fontWeight: "inherit",
  },
  repNumberACV: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    minWidth: "92px",
    fontWeight: "inherit",
  },
  repNumberPercent: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    minWidth: "90px",
    fontWeight: 600,
    cursor: "pointer",
  },
  repTextH: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "left",
    fontWeight: 600,
  },
  repNumberH: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    fontWeight: 600,
  },
  tableHeader: {
    fontWeight: 600,
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    fontSize: "15px",
    whiteSpace: "normal",
    textAlign: "center",
  },
  repHeader: {
    fontWeight: 600,
    // border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    // minWidth: "120px",
    outline: "lightgrey solid 0.5px",
    // outlineOffset: "-0.5px",
  },
  repHeaderSortable: {
    fontWeight: 600,
    padding: "5px",
    color: "inherit",
    // minWidth: "120px",
    outline: "lightgrey solid 0.5px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.04)",
    },
  },
  repCell: {
    // border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    // minWidth: "180px",
    // outline: "lightgrey solid 0.5px",
    // outlineOffset: "-0.5px",
  },
  dataCell: {
    border: "0.5px solid lightgrey",
    padding: "5px",
    color: "inherit",
    textAlign: "right",
    // minWidth: "100px",
  },
  inner: {
    height: 375,
    minWidth: 500,
  },
  chart: {
    height: "100%",
  },
  tableCell: {
    whiteSpace: "normal",
  },
  indentName: {
    paddingLeft: 30,
  },
  blackLabel: {
    color: "black",
  },
  inputFieldContainers: {
    marginBottom: 10,
    padding: 10,
    [theme.breakpoints.up("lg")]: {
      paddingRight: 0,
    },
  },
  fontBold: {
    fontWeight: 600,
  },
  stickyColumn: {
    minWidth: 200,
    left: 0,
    position: "sticky",
    zIndex: theme.zIndex.appBar + 1,
  },
  mainTable: {
    maxHeight: "80vh",
    overflow: "auto",
    border: "0.5px solid lightgrey",
  }
}));

export default function MultiFieldPOCTable(props) {
  const classes = useStyle();
  const tableRef = React.createRef();
  const tableContainerRef = useRef();

  const [isOverflowing, setIsOverflowing] = useState(false);
  const [rowPin, setrowPin] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const [isSticky, setIsSticky] = useState(false);
  const [parentWidth, setparentWidth] = useState();
  const [isRegion, setIsRegion] = useState(true);
  
  // Enhanced sorting states
  const [sortField, setSortField] = useState("count"); // Default to # of Opps (count)
  const [sortDirection, setSortDirection] = useState("desc");
  const [sortedData, setSortedData] = useState([]);

  const HtmlTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "rgb(255,255,255,0.8)",
      color: "black",
      fontFamily: "roboto",
      fontSize: theme.typography.pxToRem(14),
      borderRadius: "1rem",
      padding: "0px",
      boxShadow: "0 0.1rem 0.1rem 0",
      marginTop: "0.4rem",
    },
  }))(Tooltip);

  const projectedYieldTooltip = (
    <>
      {Array(1)
        .fill()
        .map((item) => (
          <>
            <div
              style={{
                borderRadius: "0.3rem",
                padding: "0px",
                margin: 0,
                borderWidth: "0.3rem",
              }}
            >
              <div className="container">
                <Typography
                  style={{ padding: "0.1rem" }}
                  className="heading-style"
                >{`(Attainment / Quota) / # of Reps in team`}</Typography>
              </div>
            </div>
          </>
        ))}
    </>
  );

  let countinc = 0;
  let globalExpand = [];

  const handleExpandClick = (rowId) => {
    setExpandedRows((prevExpandedRows) => {
      const isRowExpanded = prevExpandedRows.includes(rowId);
      if (isRowExpanded) {
        return prevExpandedRows.filter((expandedRow) => expandedRow !== rowId);
      } else {
        return [...prevExpandedRows, rowId];
      }
    });
  };

  useEffect(() => {
    setExpandedRows(globalExpand);
  }, []);

  const globalExpandData = (con) => {
    if (con === true) {
      setExpandedRows(globalExpand);
      setIsRegion(true);
    } else {
      setExpandedRows([]);
      setIsRegion(false);
    }
  };

  const uniqueCols = props.uniqueCols || [];
  const uniqueMonths = props.uniqueMonths || [];

  // Function to calculate totals for each technology/company
  const calculateTotals = (technology) => {
    const totalData = props.data.filter(f => f[props.field] === technology);
    const totalCount = totalData.reduce((a, b) => a + (b.count || 0), 0);
    const totalAcv = totalData.reduce((a, b) => a + (b.acv || 0), 0);
    return { totalCount, totalAcv };
  };

  // Enhanced sorting function
  const handleSort = (field) => {
    let newDirection = 'desc';
    if (sortField === field) {
      // Toggle direction if same field
      newDirection = sortDirection === 'desc' ? 'asc' : 'desc';
    } else {
      // Set default direction based on field type
      if (field === 'alphabetical') {
        newDirection = 'asc'; // Default alphabetical sorting to ascending
      } else {
        newDirection = 'desc'; // Default numerical sorting to descending
      }
    }
    
    setSortField(field);
    setSortDirection(newDirection);
  };

  // Sort the uniqueCols based on selected criteria
  useEffect(() => {
    // Separate Total row from other rows
    const totalRow = sortField === 'count' ? 'Total' : uniqueCols.find(col => col === 'Total');
    const nonTotalCols = sortField === 'count' ? props.uniqueCountCols.filter(col => col !== 'Total') : uniqueCols.filter(col => col !== 'Total');
    
    // Sort only the non-Total rows
    // const sortedNonTotalCols = [...nonTotalCols].sort((a, b) => {
    //   if (sortField === 'alphabetical') {
    //     // Alphabetical sorting - case insensitive
    //     const nameA = a.toString().toLowerCase();
    //     const nameB = b.toString().toLowerCase();
        
    //     if (sortDirection === 'asc') {
    //       return nameA.localeCompare(nameB);
    //     } else {
    //       return nameB.localeCompare(nameA);
    //     }
    //   } else {
    //     // Numerical sorting (count or acv)
    //     const totalsA = calculateTotals(a);
    //     const totalsB = calculateTotals(b);
        
    //     let valueA, valueB;
    //     if (sortField === 'count') {
    //       valueA = totalsA.totalCount;
    //       valueB = totalsB.totalCount;
    //     } else {
    //       valueA = totalsA.totalAcv;
    //       valueB = totalsB.totalAcv;
    //     }
        
    //     if (sortDirection === 'asc') {
    //       return valueA - valueB;
    //     } else {
    //       return valueB - valueA;
    //     }
    //   }
    // });

    const sortedNonTotalCols = [...nonTotalCols].sort((a, b) => {
  if (sortField === 'alphabetical') {
    const nameA = a.toString().toLowerCase();
    const nameB = b.toString().toLowerCase();
    
    if (sortDirection === 'asc') {
      return nameA.localeCompare(nameB);
    } else {
      return nameB.localeCompare(nameA);
    }
  } else {
    // Use direct field access instead of calculateTotals
    const dataA = props.data.find(item => item[props.field] === a && item.month === 'Total');
    const dataB = props.data.find(item => item[props.field] === b && item.month === 'Total');
    
    let valueA, valueB;
    if (sortField === 'count') {
      valueA = dataA.count || 0;
      valueB = dataB.count || 0;
    } else {
      valueA = dataA.acv || 0;
      valueB = dataB.acv || 0;
    }
    
    if (sortDirection === 'asc') {
      return valueA - valueB;
    } else {
      return valueB - valueA;
    }
  }
});
    
    // Always put Total row at the end
    const finalSortedData = totalRow 
      ? [...sortedNonTotalCols, totalRow] 
      : sortedNonTotalCols;
    
    setSortedData(finalSortedData);
  }, [uniqueCols, sortField, sortDirection, props.data]);

  const ast = (x) => (
    <>
      <span>{x}</span> <span style={{ color: "#ed7d31" }}>*</span>
    </>
  );
  const ast2 = (x) => (
    <>
      <span style={{ color: "#ed7d31" }}>*</span>&nbsp; <span>{x}</span>{" "}
    </>
  );

  useEffect(() => {
    const tableContainer = document.getElementById("myTableContainer-second");

    const handleOverflowCheck = () => {
      if (tableContainer) {
        setIsOverflowing(
          tableContainer.scrollWidth > tableContainer.offsetWidth
        );
      }
    };

    handleOverflowCheck();
    window.addEventListener("resize", handleOverflowCheck);

    return () => {
      window.removeEventListener("resize", handleOverflowCheck);
    };
  }, []);

  useEffect(() => {
    const tableContainer = tableContainerRef.current;

    const handleScroll = () => {
      if (tableContainer.scrollLeft > 0) {
        setIsSticky(true);
      } else {
        setIsSticky(false);
      }

      if (tableContainer.scrollTop > 0) {
        setrowPin(true);
      } else {
        setrowPin(false);
      }
    };

    if (tableContainer) {
      tableContainer.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (tableContainer) {
        tableContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  useEffect(() => {
    const updateWidth = () => {
      if (tableContainerRef.current) {
        const width = tableContainerRef.current.getBoundingClientRect().width;
        setparentWidth(width);
      }
    };

    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => {
      window.removeEventListener('resize', updateWidth);
    };
  }, []);

  return (
    <div
      className={classes.root}
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <CardContent className={classes.content}>   
        <Grid container justify="flex-start">
          {parentWidth !== undefined && (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginBottom: "0.6rem",
                width: "100%",
              }}
            >
              <CopyTablesObject tableRef={tableRef} />
            </div>
          )}
          
          <TableContainer
            className={classes.mainTable}
            id="myTableContainer-second"
            ref={tableContainerRef}
            style={{
              borderLeft: isSticky ? "0.5px solid lightgrey" : "",
              borderTop: rowPin ? "0.5px solid lightgrey" : "",
              width: "100%",
            }}
          >
            <Table
              ref={tableRef}
              size="small"
              aria-label="transposed table"
              style={{ 
                tableLayout: "fixed", 
                width: "100%",
                minWidth: `${200 + (uniqueMonths.length * 200)}px` // Ensure minimum width for scrolling
              }}
              data-test={
                props.dataTest
                  ? props.dataTest
                  : "quota-attainment-detail-table"
              }
            >
              <TableHead className={classes.stickyHeader}>
                {/* First header row - Months */}
               <TableRow className={`${classes.stickyHeader}`}>
                  <TableCell
                    align="center"
                    className={`${classes.sticky} ${classes.repHeader}`}
                    // rowSpan={2}
                    style={{
                      background: "white",
                      width: "200px",
                      zIndex: 20,
                    }}
                  >
                    Month
                  </TableCell>
                  {uniqueMonths.map((month, index) => (
                    <TableCell
                      key={month}
                      align="center"
                      colSpan={2}
                      className={`${classes.sticky} ${classes.repHeader}`}
                      style={{
                        background: index % 2 === 0 ? "#4471c4" : "#5b9bd5",
                        color: "white",
                        minWidth: "200px",
                      }}
                    >
                      {month}
                    </TableCell>
                  ))}

                  {uniqueMonths.length === 0 && (
                    <TableCell
                      colSpan={2}
                      className={classes.repHeader}
                      style={{ width: 400, textAlign: "center" }}
                    >
                      No data available
                    </TableCell>
                  )}
                </TableRow>
                
                {/* Second header row - Sub headers */}
                <TableRow className={`${classes.stickyHeader}`}>
                  <TableCell 
                    className={`${classes.sticky} ${classes.repHeaderSortable}`}
                    onClick={() => handleSort("alphabetical")}
                    style={{
                      background: "white",
                      zIndex: 20,
                      cursor: "pointer",
                    }}
                  >
                    {props.label}
                    <TableSortLabel
                      active={sortField === "alphabetical"}
                      direction={sortField === "alphabetical" ? sortDirection : "asc"}
                    />
                  </TableCell>
                  {uniqueMonths.map((month) => (
                    <React.Fragment key={`${month}-subheaders`}>
                      <TableCell
                        align="center"
                        className={month === 'Total' ? classes.repHeaderSortable : classes.repHeader}
                        // style={{ minWidth: "100px" }}
                        onClick={month === 'Total' ? () => handleSort("count") : undefined}
                      >
                        # of Opps
                        {month === 'Total' && (
                          <TableSortLabel
                            active={sortField === "count"}
                            direction={sortField === "count" ? sortDirection : "desc"}
                          />
                        )}
                      </TableCell>
                      <TableCell
                        align="center"
                        className={month === 'Total' ? classes.repHeaderSortable : classes.repHeader}
                        // style={{ minWidth: "100px" }}
                        onClick={month === 'Total' ? () => handleSort("acv") : undefined}
                      >
                        {props.Value_Label || "Value"}
                        {month === 'Total' && (
                          <TableSortLabel
                            active={sortField === "acv"}
                            direction={sortField === "acv" ? sortDirection : "desc"}
                          />
                        )}
                      </TableCell>
                    </React.Fragment>
                  ))}
                </TableRow>
              </TableHead>
              
              <TableBody>
                {/* Render rows for each unique column (technology/company) using sorted data */}
                {sortedData.map((technology, techIndex) => {
                  const totals = calculateTotals(technology);
                  
                  return (
                    <StyledTableRow key={technology}>
                      {/* Technology/Company name in first column */}
                      <TableCell
                        className={`${classes.sticky} ${classes.repCell}`}
                        style={
                          techIndex % 2 === 0
                            ? {
                                background: "#ffffff",
                                fontWeight: 600,
                                zIndex: 11,
                                width: "200px",
                                position: "sticky",
                                left: 0,
                                boxShadow: isSticky ? "2px 0px 4px rgba(0,0,0,0.1)" : "none",
                              }
                            : {
                                background: "#f5f5f5",
                                fontWeight: 600,
                                zIndex: 11,
                                width: "200px",
                                position: "sticky",
                                left: 0,
                                boxShadow: isSticky ? "2px 0px 4px rgba(0,0,0,0.1)" : "none",
                              }
                        }
                      >
                        {technology}
                      </TableCell>
                      
                      {/* Data cells for each month */}
                      {uniqueMonths.map((month) => {
                        const d = props.data.filter(f => f.month === month && f[props.field] === technology);
                        let acv = '-'
                        let count = '-'
                        if(d.length > 0){
                          acv = countOrACVFormatter(d.reduce((a,b) => a+b.acv, 0), true)
                          count = countOrACVFormatter(d.reduce((a,b) => a+b.count, 0), false)
                        }
                        return (
                          <React.Fragment key={`${technology}-${month}`}>
                            <TableCell
                              align="right"
                              className={classes.dataCell}
                              style={{
                                cursor: 'pointer', 
                                ...(technology === 'Total' && { fontWeight: 600 }),
                                ...(month === 'Total' && { fontWeight: 600 })
                              }}
                              onClick={() => props.handleChangeLocation(
                "drilldownOnGraph",
                {
                  row: technology === 'Total' ? uniqueCols.filter(f => f !== 'Total') : [technology],
                  cell: month === 'Total' ? uniqueMonths.filter(f => f !== 'Total') : [month],
                },
                props.field,
                'month',
                props.label
              )}
                            >
                              {count}
                            </TableCell>
                            <TableCell
                              align="right"
                              className={classes.dataCell}
                              style={{
                                cursor: 'pointer',
                                ...(technology === 'Total' && { fontWeight: 600 }),
                                ...(month === 'Total' && { fontWeight: 600 })
                              }}
                              onClick={() => props.handleChangeLocation(
                "drilldownOnGraph",
                {
                  row: technology === 'Total' ? uniqueCols.filter(f => f !== 'Total') : [technology],
                  cell: month === 'Total' ? uniqueMonths.filter(f => f !== 'Total') : [month],
                },
                props.field,
                'month',
                props.label
              )}
                            >
                              {acv}
                            </TableCell>
                          </React.Fragment>
                        );
                      })}
                    </StyledTableRow>
                  );
                })}
                
                {uniqueCols.length === 0 && (
                  <TableRow>
                    <TableCell
                      colSpan={1 + (uniqueMonths.length * 2)}
                      className={classes.repCell}
                      style={{ textAlign: "center", padding: "20px" }}
                    >
                      No data available
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </CardContent>
    </div>
  );
}